import request from '@/utils/request'


// 微信扫码登录
export function login(code) {
    return request({
      url: '/sys/sysUser/doLogin?code='+code,
      method: 'get'
    })
}

// 账号密码登录
export function loginByAccount(userName, pwd) {
    return request({
      url: '/sys/sysUser/doLoginByAccount',
      method: 'get',
      params: { userName, pwd }
    })
}

// 发送注册短信验证码
export function sendRegisterSmsCode(phone) {
    return request({
      url: '/sys/sysUser/sendRegisterSmsCode',
      method: 'get',
      params: { phone }
    })
}

// 手机号注册
export function registerByPhone(phone, verifyCode, pwd) {
    return request({
      url: '/sys/sysUser/registerByPhone',
      method: 'post',
      params: { phone, verifyCode, pwd }
    })
}

// 发送忘记密码短信验证码
export function sendResetPwdSmsCode(phone) {
    return request({
      url: '/sys/sysUser/sendResetPwdSmsCode',
      method: 'get',
      params: { phone }
    })
}

// 通过手机号重置密码
export function resetPwdByPhone(phone, verifyCode, pwd) {
    return request({
      url: '/sys/sysUser/resetPwdByPhone',
      method: 'post',
      params: { phone, verifyCode, pwd }
    })
}

// 获取用户详细信息
export function getInfo(userUniqueId) {
    return request({
      url: '/sys/sysUser/getUserInfo?userUniqueId='+userUniqueId,
      method: 'get'
    })
}

// 退出方法
export function logOut() {
  return request({
    url: '/sys/sysUser/logOut',
    method: 'get'
  })
}


// 修改用户昵称
export function updateNickName(nickName) {
  return request({
    url: '/sys/sysUser/updateNickName',
    method: 'get',
    params: { nickName }
  })
}

/**
 * 查询直播间下拉列表
 * @returns 
 */
export function getTypeList() {
  return request({
    url: '/liveRoom/liveType/list',
    method: 'get'
  })
}
